import { queryOptions, useQuery } from '@tanstack/react-query';

import { ImpersonationBroker, type INote, type UserSessionContext } from '../../../extViewmodels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { queryKeys } from '../data/queryKeys';

export function dealNoteQueryOptions(userSession: UserSessionContext, noteId: string | undefined) {
	return queryOptions<INote, Error>({
		queryKey: queryKeys.focusedView.dealNote(noteId),
		queryFn: () =>
			userSession.webServiceHelper.callAsync<INote>(
				ImpersonationBroker.composeApiUrl({ urlPath: `note/${noteId}` }),
				'GET'
			),
		meta: { errorLogging: { category: 'FocusedViewDeal', action: 'DealNoteQuery-Error' } },
	});
}

/**
 * Loads a deal-form `Note` field's saved note. The Update Deal schema returns
 * Note values as bare note ids, so the body has to be fetched separately —
 * the legacy `FormFieldViewModel` does the same via `field.note.load()`.
 */
export function useDealNote(noteId: string | undefined) {
	const userSession = useUserSession();

	return useQuery({ ...dealNoteQueryOptions(userSession, noteId), enabled: !!noteId });
}
